import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import {
  addNewCarSell,
  getCarBrandType,
  getCarType,
  getFinanceType,
  getPersonList,
  getServiceType,
  getInsurance,
  getCarBroker,
  getCarSellQuery,
  getLocation
} from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getUserID, months, ToTimeStamp } from "../../util/utils";

class CarSold extends Component {
  constructor(props) {
    super(props);
    if (props.sale) {

    }

    this.state = {
      isLoading: false,
      selectedSalesPerson: 0,
      personList: [],
      carTypeList: [],
      carBrandTypeList: [],
      financeTypeList: [],
      serviceTypeList: [],
      insuranceList:[],
      CarBrokerList:[],
      locationList: [],
      selectedCarBrand: 0,
      selectedServiceType: 0,
      selectedFinanceingType: 0,
      selectedCarType: 0,
      selectedInsurance: 0,
      selectedCarBroker: 0,
      selectedSalesDate: new Date(),
      selectedLocation: 0,
      customer: "",
      carModal: "",
      gwBack: false,
      financeing: false,
      carBroker: false,
      insurance: false,
      service: false,
      carSellLoaded: false,
    };
  }

  componentDidMount() {
    if (this.props.sellId) this.getCarSellData();
    this.getFinanceTypeList();
    this.getCarBrandTypeList();
    this.getCarTypeList();
    this.getServiceTypeList();
    this.getInsuranceList();
    this.getCarBrokerList();
    this.getLocationList();
  }

  getCarSellData = () => {

    apiCall(
      METHOD.QUERY,
      getCarSellQuery(this.props.sellId),
      (data) => this.handleCarSellResponse(data.car_sell),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  getCarBrandTypeList = () => {
    const { start, end } = this.state;
    apiCall(
      METHOD.QUERY,
      getCarBrandType(getUserID(), start, end),
      (data) => this.handleCarBrandTypeListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  getLocationList = () => {
    apiCall(
      METHOD.QUERY,
      getLocation(getUserID(), 0, 0),
      (data) => this.handleLocationListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleLocationListResponse = (data) => {
    this.setState({
      locationList: data.location_list,
    });
  };

  getPersonList = (locationId) => {
    apiCall(
      METHOD.QUERY,
      getPersonList(getUserID(), 0, 0, parseInt(locationId)),
      (data) => this.handlePersonListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handlePersonListResponse = (data) => {
    const personList = data.sales_person_list;
    personList.sort((a,b) => a.surname.localeCompare(b.surname));

    this.setState({
      personList: personList,
    });
  };

  getInsuranceList = () => {
    apiCall(
      METHOD.QUERY,
      getInsurance(getUserID(), 0, 0),
      (data) => this.handleInsuranceListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleInsuranceListResponse = (data) => {
    this.setState({
      insuranceList: data.insurance_list,
    });
  };

  getCarBrokerList = () => {
    apiCall(
      METHOD.QUERY,
      getCarBroker(getUserID(), 0, 0),
      (data) => this.handleCarBrokerListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleCarBrokerListResponse = (data) => {
    this.setState({
      CarBrokerList: data.car_broker_list,
    });
  };

  getServiceTypeList = () => {
    apiCall(
      METHOD.QUERY,
      getServiceType(getUserID(), 0, 0),
      (data) => this.handleServiceTypeListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleServiceTypeListResponse = (data) => {
    this.setState({
      serviceTypeList: data.service_type_list,
    });
  };

  getFinanceTypeList = () => {
    apiCall(
      METHOD.QUERY,
      getFinanceType(getUserID(), 0, 0),
      (data) => this.handleFinanceTypeListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleFinanceTypeListResponse = (data) => {
    this.setState({
      financeTypeList: data.financing_type_list,
    });
  };

  getCarTypeList = () => {
    apiCall(
      METHOD.QUERY,
      getCarType(getUserID(), 0, 0),
      (data) => this.handleCarTypeListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleCarTypeListResponse = (data) => {
    this.setState({
      carTypeList: data.car_type_list,
    });
  };

  getCarBrandTypeList = () => {
    apiCall(
      METHOD.QUERY,
      getCarBrandType(getUserID(), 0, 0),
      (data) => this.handleCarBrandTypeListResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };
  handleCarSellResponse = (data) => {
    this.setState({
      selectedSalesPerson: data.sales_person_id,
      selectedSalesDate: this.parseDate(data.sales_date),
      selectedInsurance: JSON.parse(data.insurance_id),
      insurance: JSON.parse(data.insurance_id) === null ? false : true,
      customer: data.customer,
      selectedCarBrand: data.car_brand_id,
      selectedCarBroker: data.car_broker_id,
      carBroker: JSON.parse(data.car_broker_id) === null ? false : true,
      carModal: data.car_model,
      selectedCarType: data.car_type_id,
      financeing: JSON.parse(data.financing),
      selectedFinanceingType: data.financing_type_id,
      gwBack: JSON.parse(data.gw_back),
      service: JSON.parse(data.service),
      selectedServiceType: data.service_type_id,
      carSellLoaded: true
    });
  };

  handleCarBrandTypeListResponse = (data) => {
    data.car_brand_list.sort((a,b) => b.priority - a.priority);

    this.setState({
      carBrandTypeList: data.car_brand_list,
    });
  };

  handleLoader = (isLoading) => {
    this.setState({
      isLoading,
    });
  };
  parseDate = (input) => {
    var parts = input.match(/(\d+)/g);
    // note parts[1]-1
    return new Date(parts[2], parts[1]-1, parts[0]);
  };

  handleLocationChange = (locationId) => {
    if(locationId === 0 || locationId === "0") return;
    this.getPersonList(locationId);
    this.setState({
      selectedLocation: parseInt(locationId)
    });
  }

  generateTimeStamp = (_date) => {
    const monthNumber = _date.getMonth();
    const _year = _date.getFullYear();
    const _hour = _date.getHours();
    const _minutes = _date.getMinutes();
    const _seconds = _date.getSeconds();
    var date = _date.getDate();
    var month = months[monthNumber];
    var year = _year;
    var hours = _hour;
    if (hours <= 2 ){
      hours = 12; //the middle of the day, to avoid timezone-problems
    }
    var minutes = _minutes;
    var seconds = _seconds;

    var shortDateTime =
      month +
      " " +
      date +
      " " +
      year +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;

    return ToTimeStamp(shortDateTime);
  };
  handleSubmit = () => {
    const {
      selectedSalesPerson,
      selectedSalesDate,
      selectedInsurance,
      customer,
      selectedCarBrand,
      selectedCarBroker,
      carModal,
      selectedCarType,
      selectedFinanceingType,
      selectedServiceType,
      gwBack,
      financeing,
      service,
      insurance,
      carBroker,
    } = this.state;
    if (!customer) {
      toast.warn(this.props.t("newCarSold.customerValidation"));
    } else if (parseInt(selectedSalesPerson) === 0) {
      toast.warn(this.props.t("newCarSold.personSelectValidation"));
    } else if (parseInt(selectedCarBrand) === 0) {
      toast.warn(this.props.t("newCarSold.carBrandValidation"));
    } else if (parseInt(selectedCarType) === 0) {
      toast.warn(this.props.t("newCarSold.carTypeValidation"));
    } else {
      let timeStamp;
      if (selectedSalesDate) {
        timeStamp = this.generateTimeStamp(selectedSalesDate);
      } else {
        timeStamp = 0;
      }
      apiCall(
        METHOD.QUERY,
        addNewCarSell(
          this.props.sellId,
          getUserID(),
          customer,
          carModal,
          selectedSalesPerson,
          timeStamp,
          selectedCarBrand,
          selectedCarType,
          financeing ? selectedFinanceingType : null,
          service ? selectedServiceType : null,
          gwBack ? 1 : 0,
          financeing ? 1 : 0,
          service ? 1 : 0,
          carBroker ? selectedCarBroker : null,
          insurance ? selectedInsurance : null,
        ),
        (data) => this.handleCreateSalesCarResponse(data),
        (isLoading) => {
          this.setState({ createIsLoading: isLoading });
        },
        (data) => {
          toast.error(this.props.t(data.message));
        }
      );
    }
  };

  handleCreateSalesCarResponse = (data) => {
    toast.success(this.props.t(data.message));
    this.props.handleNewCarModal(false);
  };

  render() {
    const {
      isLoading,
      createIsLoading,
      selectedLocation,
      selectedSalesPerson,
      personList,
      selectedSalesDate,
      customer,
      carBrandTypeList,
      selectedCarBrand,
      carModal,
      selectedCarType,
      carTypeList,
      selectedFinanceingType,
      financeTypeList,
      serviceTypeList,
      insuranceList,
      CarBrokerList,
      locationList,
      selectedServiceType,
      selectedInsurance,
      selectedCarBroker,
      gwBack,
      financeing,
      carBroker,
      insurance,
      service,
    } = this.state;
    const { handleNewCarModal } = this.props;

    if (this.props.sellId && !this.state.carSellLoaded) return <></>;

    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="d-block">
              <div
                className="modal d-block"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        {t("newCarSold.lblNewSalesCar")}
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          handleNewCarModal(false);
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {isLoading && (
                        <div className="loader-container">
                          <div className="loader-logo">
                            <div className="sk-chase">
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                              <div className="sk-chase-dot"></div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> {t("newCarSold.salesDate")}</label>
                            <br />
                            <DatePicker
                              selected={selectedSalesDate}
                              locale={localStorage.getItem('i18nextLng') ?? 'de'}
                              className="form-control"
                              popperPlacement="bottom-end"
                              onChange={(date) => {
                                this.setState({
                                  selectedSalesDate: date,
                                });
                              }}
                              dateFormat="d.MM.yyyy"
                            />
                          </div>

                          <div className="form-group">
                            <label>
                              {t("managePersonList.locationPlaceHolder")}
                            </label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                return this.handleLocationChange(e.target.value);
                              }}
                              onChange={(e) => {
                                return this.handleLocationChange(e.target.value);
                              }}
                              value={JSON.parse(JSON.stringify(selectedLocation))}
                            >
                              <option value={0}>
                                {t("managePersonList.locationSelection")}
                              </option>
                              {locationList &&
                                locationList.map((item, index) => {
                                  const { name, id } = item;
                                  return (
                                    <option
                                      key={index}
                                      value={id}
                                    >
                                      {name && name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label> {t("newCarSold.salesPerson")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedSalesPerson: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedSalesPerson: e.target.value,
                                });
                              }}
                              value={selectedSalesPerson}
                              disabled={!parseInt(selectedLocation)}
                            >
                              <option value="0">
                                {t("newCarSold.selectSalesPerson")}
                              </option>
                              {personList &&
                                personList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.surname}, {item.firstname}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.customer")}</label>
                            <input
                              type="text"
                              value={customer}
                              onChange={(e) => {
                                this.setState({
                                  customer: e.target.value,
                                });
                              }}
                              className="form-control"
                            />
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.carBrand")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedCarBrand: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedCarBrand: e.target.value,
                                });
                              }}
                              value={selectedCarBrand}
                            >
                              <option value="0">{t("newCarSold.selectCarBrand")}</option>
                              {carBrandTypeList &&
                                carBrandTypeList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.carType")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedCarType: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedCarType: e.target.value,
                                });
                              }}
                              value={selectedCarType}
                            >
                              <option value="0">{t("newCarSold.selectCarType")}</option>
                              {carTypeList &&
                                carTypeList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.carModal")}</label>
                            <input
                              type="text"
                              value={carModal}
                              onChange={(e) => {
                                this.setState({
                                  carModal: e.target.value,
                                });
                              }}
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="custom-control custom-checkbox mb-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customCheck3"
                                checked={(financeing === 'true' || financeing === true)}
                                onChange={(e) => {
                                  let financeing;
                                  if (e.target.checked) {
                                    financeing = true;
                                  } else {
                                    financeing = false;
                                  }
                                  this.setState({ financeing });
                                }}
                              />
                              <label
                                className="custom-control-label pointer"
                                htmlFor="customCheck3"
                              >
                                {" "}
                                {t("newCarSold.financing")}
                              </label>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.financingType")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedFinanceingType: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedFinanceingType: e.target.value,
                                });
                              }}
                              disabled={
                                financeing !== true && financeing !== 'true'
                              }
                              value={selectedFinanceingType}
                            >
                              <option value="0">
                                {t("newCarSold.selectFinancingType")}
                              </option>
                              {financeTypeList &&
                                financeTypeList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                checked={(service === 'true' || service === true)}
                                onChange={(e) => {
                                  let service;
                                  if (e.target.checked) {
                                    service = true;
                                  } else {
                                    service = false;
                                  }
                                  this.setState({ service });
                                }}
                                id="customCheck4"
                              />
                              <label
                                className="custom-control-label pointer"
                                htmlFor="customCheck4"
                              >
                                {t("newCarSold.service")}
                              </label>
                            </div>
                          </div>

                          <div className="form-group">
                            <label>{t("newCarSold.serviceType")}</label>
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedServiceType: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedServiceType: e.target.value,
                                });
                              }}
                              value={selectedServiceType}
                              disabled={
                                service !== true && service !== 'true'
                              }
                            >
                              <option value="0">
                                {t("newCarSold.selectServiceType")}
                              </option>
                              {serviceTypeList &&
                                serviceTypeList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="form-group">
                            <div className="custom-control custom-checkbox mb-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customCheck1"
                                checked={(gwBack === 'true' || gwBack === true)}
                                onChange={(e) => {
                                  let gwBack;
                                  if (e.target.checked) {
                                    gwBack = true;
                                  } else {
                                    gwBack = false;
                                  }
                                  this.setState({ gwBack });
                                }}
                              />
                              <label
                                className="custom-control-label pointer"
                                htmlFor="customCheck1"
                              >
                                {" "}
                                {t("newCarSold.gwBack")}
                              </label>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="custom-control custom-checkbox mb-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customCheck5"
                                checked={(insurance === 'true' || insurance === true)}
                                onChange={(e) => {
                                  let insurance;
                                  if (e.target.checked) {
                                    insurance = true;
                                  } else {
                                    insurance = false;
                                  }
                                  this.setState({ insurance });
                                }}
                              />
                              <label
                                className="custom-control-label pointer"
                                htmlFor="customCheck5"
                              >
                                {" "}
                                {t("newCarSold.insurance")}
                              </label>
                            </div>
                          </div>
                          <div className="form-group">
                          <label>{t("newCarSold.insuranceType")}</label>
                          <select
                            className="custom-select"
                            onMouseUp={(e) => {
                              this.setState({
                                selectedInsurance: JSON.parse(e.target.value),
                              });
                            }}
                            onChange={(e) => {
                              this.setState({
                                selectedInsurance: JSON.parse(e.target.value),
                              });
                            }}
                            disabled={
                              insurance !== true && insurance !== 'true'
                            }
                            value={selectedInsurance}
                          >
                            <option value="0">
                              {t("newCarSold.selectInsurance")}
                            </option>
                            {insuranceList &&
                              insuranceList.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.id}
                                  >
                                    {item.name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="form-group">
                            <div className="custom-control custom-checkbox mb-2">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customCheck6"
                                checked={(carBroker === 'true' || carBroker === true)}
                                onChange={(e) => {
                                  let carBroker;
                                  if (e.target.checked) {
                                    carBroker = true;
                                  } else {
                                    carBroker = false;
                                  }
                                  this.setState({ carBroker });
                                }}
                              />
                              <label
                                className="custom-control-label pointer"
                                htmlFor="customCheck6"
                              >
                                {" "}
                                {t("newCarSold.CarBroker")}
                              </label>
                            </div>
                          </div>
                          <div className="form-group">
                            <select
                              className="custom-select"
                              onMouseUp={(e) => {
                                this.setState({
                                  selectedCarBroker: e.target.value,
                                });
                              }}
                              onChange={(e) => {
                                this.setState({
                                  selectedCarBroker: e.target.value,
                                });
                              }}
                              disabled={
                                carBroker !== true && carBroker !== 'true'
                              }
                              value={selectedCarBroker}
                            >
                              <option value="0">
                                {t("newCarSold.selectCarBroker")}
                              </option>
                              {CarBrokerList &&
                                CarBrokerList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary width-100p mr-2"
                        onClick={() => {
                          this.props.handleNewCarModal(false);
                        }}
                      >
                        {t("newCarSold.cancel")}
                      </button>

                      {createIsLoading ? (
                        <button className="btn btn-primary width-100p mr-2">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {t("newCarSold.submit")}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary width-100p "
                          disabled={isLoading}
                          onClick={() => {
                            this.handleSubmit();
                          }}
                        >
                          {t("newCarSold.submit")}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(CarSold));
